module.exports = __webpack_public_path__ + "images/blog_guide/flow01_ae4e433137d77163e72377e5d16ca2d1.png";